import { useState, useEffect } from "react";
import H2 from "@/atoms/text/H2";
import Image from "../atoms/Image";
import Link from "next/link";
import { isMobileScreen } from "@/utils/functions";
import { AestheticBg1, AestheticBg2, AestheticBg3 } from "@/atoms/Icons";

const ProudMember = ({ content, bgColor, color, image, href }) => {
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    setIsMobile(isMobileScreen);
  }, []);

  return (
    <section className={`aestheticBg ps-r pv-8-d pv-10 bc-${bgColor}`}>
      <div className="container ta-center fx fx--r-d fx--c fx--ch fx--cv">
        <H2
          color={color}
          className="bold mr-7-d mb-reset-d mb-7"
          dangerouslySetInnerHTML={{ __html: content }}
        />
        <Link href={href}>
          <Image
            isBannerImg={image.isBannerImg}
            fileName={image.fileName}
            fileFormat={image.fileFormat}
            alt={image.altText}
            has2XWebp
            desktopWidth={image.desktopWidth}
            desktopHeight={image.desktopHeight}
          />
        </Link>
      </div>
      {isMobile ? (
        <AestheticBg3 className="aestheticBg-right" />
      ) : (
        <>
          <AestheticBg1 className="aestheticBg-right aestheticBg-flip" />
          <AestheticBg2 className="aestheticBg-left aestheticBg-flip" />
        </>
      )}
    </section>
  );
};

ProudMember.defaultProps = {
  bgColor: "grad-blue",
  color: "white",
  href: "#",
};
export default ProudMember;
